import './styles.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { router } from './router.js';
import { usePlatformStore } from './store.js';
import { platformNavigation } from './navigation.js';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);

router.beforeEach((to) => platformNavigation(to, usePlatformStore(pinia)));

app.mount('#app');
